import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NgControl} from '@angular/forms';

@Directive({
  selector: '[Currency]'
})
export class CurrencyDirective implements OnInit {
  @Input() precision = 10;
  private elementRef: HTMLInputElement
  value: any;

  constructor(private el: ElementRef, private ngControl: NgControl) {
    this.elementRef = this.el.nativeElement;
  }

  scientificToDecimal(num: any) {
    if (!num.toString().includes('e')) return num;
    const nsign = Math.sign(num);
    //remove the sign
    num = Math.abs(num);
    //if the number is in scientific notation remove it
    if (/\d+\.?\d*e[\+\-]*\d+/i.test(num)) {
      const zero = '0';
      const parts = String(num).toLowerCase().split('e'); //split into coeff and exponent
      const e = parts.pop() ?? 0; //store the exponential part
      let l = Math.abs(+e); //get the number of zeros
      const sign = +e / l;
      const coeff_array = parts[0].split('.');
      if (sign === -1) {
        l = l - coeff_array[0].length;
        if (l < 0) {
          num = coeff_array[0].slice(0, l) + '.' + coeff_array[0].slice(l) + (coeff_array.length === 2 ? coeff_array[1] : '');
        } else {
          num = zero + '.' + new Array(l + 1).join(zero) + coeff_array.join('');
        }
      } else {
        const dec = coeff_array[1];
        if (dec)
          l = l - dec.length;
        if (l < 0) {
          num = coeff_array[0] + dec.slice(0, l) + '.' + dec.slice(l);
        } else {
          num = coeff_array.join('') + new Array(l + 1).join(zero);
        }
      }
    }

    return nsign < 0 ? '-' + num : num;
  };

  countDecimal(value: number): number {
    if (Math.floor(value.valueOf()) === value.valueOf()) {
      return 0;
    }
    if (value.toString().split('.').length === 1) {
      return 0;
    }
    return value.toString().split('.')[1].length || 0;
  }

  addCommas(value: any): string {
    let nStr = value.toString();
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  convertToEnglishNumber(value: string): string {
    const persianNumbers = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'];
    const arabicNumbers = ['١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩', '٠'];
    const englishNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    return value
      .split('')
      .map(
        (c) =>
          englishNumbers[persianNumbers.indexOf(c)] ||
          englishNumbers[arabicNumbers.indexOf(c)] ||
          c
      )
      .join('');
  }

  format(value: string): string | null {
    if (value === '') return null;
    let val: any = this.convertToEnglishNumber(this.scientificToDecimal(value).toString()?.replace(/\,/g, ''));

    const splittedVar = val.split('.');
    let end = '';
    if (splittedVar.hasOwnProperty(1)) {
      end = '.' + splittedVar[1].slice(0, this.precision);
    } else {
      end = '';
    }
    let numVal = 0;
    if (val !== '') {
      numVal = Number(val);
    }

    if (isNaN(numVal) || !Number.isSafeInteger(parseInt(val, 10))) {
      return null;
    }
    if (this.countDecimal(numVal) > this.precision) {
      return this.addCommas(
        Number(val.toString().slice(0, this.precision - this.countDecimal(val)))
      );
    } else {
      return this.addCommas(parseInt(val, 10)) + end;
    }
  }

  @HostListener("input", ["$event.target.value"])
  input(value: any) {
    this.elementRef.value = this.format(value) ?? value
  }


  ngOnInit() {
    this.elementRef.value = this.format(this.elementRef.value) ?? this.elementRef.value;
    this.ngControl.control?.valueChanges.subscribe((value) => {
      if (value) {
        const formatted = this.format(value.toString());
        if (formatted) {
          this.ngControl.control?.setValue(formatted, {emitEvent: false})
        }
      }
    })

  }


}
